export default {"src":"/_next/static/media/COF.33a1791f.svg","height":18,"width":18};